var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { CardHeader as MuiCardHeader } from '@mui/material';
import { CardContext } from './utils';
import Typography from '../Typography';
export var CardHeader = function (_a) {
    var title = _a.title, children = _a.children, sx = _a.sx, props = __rest(_a, ["title", "children", "sx"]);
    var size = useContext(CardContext);
    return (React.createElement(MuiCardHeader, __assign({ title: React.createElement(Typography, { variant: size === 'medium' ? 'heading3' : 'heading4', weight: "bold" }, title), sx: __assign(__assign({}, (size === 'medium'
            ? {
                mt: '20px',
                px: '24px',
                '.MuiCardHeader-action': {
                    height: '32px',
                },
            }
            : {
                mt: '14px',
                px: '16px',
                '.MuiCardHeader-action': {
                    height: '28px',
                },
            })), sx) }, props), children));
};
//# sourceMappingURL=CardHeader.js.map